import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Google Analytics 4 (gtag.js).
 *
 * ID dibaca dari REACT_APP_GA_ID pada berkas frontend/.env sehingga staging dan
 * produksi bisa memakai properti berbeda — atau dimatikan dengan mengosongkannya.
 * Nilai .env ditanam saat build, jadi perubahannya baru berlaku setelah
 * `npm run build` (atau restart dev server) dijalankan ulang.
 */
const GA_ID = (process.env.REACT_APP_GA_ID || "").trim();

/** Aktif hanya bila ID-nya berformat Measurement ID GA4 yang sah. */
export const analitikAktif = /^G-[A-Z0-9]+$/i.test(GA_ID);

function gtag() {
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}

let sudahDimuat = false;

/** Sisipkan skrip gtag.js sekali saja, saat aplikasi pertama dijalankan. */
export function muatGoogleAnalytics() {
  if (!analitikAktif || sudahDimuat) return;
  sudahDimuat = true;
  window.dataLayer = window.dataLayer || [];
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_ID)}`;
  document.head.appendChild(s);
  gtag("js", new Date());
  // Kunjungan halaman dikirim manual dari LacakHalaman: aplikasi ini SPA,
  // sehingga perpindahan menu tidak memuat ulang dokumen.
  gtag("config", GA_ID, { send_page_view: false });
}

const POLA_ID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Ganti potongan URL yang berupa ID dengan ":id" agar laporan GA tidak
 * dipenuhi ribuan alamat unik, mis. /purchase-orders/:id.
 */
export function jalurLaporan(pathname) {
  return pathname
    .split("/")
    .map((bagian) => (POLA_ID.test(bagian) || /^\d+$/.test(bagian) ? ":id" : bagian))
    .join("/");
}

let jalurTerakhir = "";

/** Kirim event page_view setiap kali route berubah. */
export function LacakHalaman() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!analitikAktif) return;
    // React StrictMode menjalankan efek dua kali saat pengembangan; kunjungan
    // yang sama berturut-turut cukup dikirim sekali.
    if (pathname === jalurTerakhir) return;
    jalurTerakhir = pathname;
    gtag("event", "page_view", {
      page_path: jalurLaporan(pathname),
      page_title: document.title,
      page_location: window.location.origin + jalurLaporan(pathname),
    });
  }, [pathname]);
  return null;
}

/**
 * Catat role pengguna sebagai user property (tanpa nama, email, atau ID user)
 * supaya laporan bisa dipilah per role.
 */
export function catatPeran(role) {
  if (!analitikAktif) return;
  gtag("set", "user_properties", { peran: role || "tamu" });
}
